/**
 * DE 7-piece bundle: client-side product feed builder.
 * Feed = Section Rendering API (/collections/all?section_id=lc-bundle-feed),
 * which is page-cached by Shopify — vs /products.json which takes ~10s/page.
 * Page 1 renders immediately (progressive); remaining pages load in parallel
 * and append. A sessionStorage cache makes repeat views instant.
 * Blocklist + category mapping ported from src/app/api/products/route.ts;
 * titles localized via the baked English→German map ([data-de-titles]).
 * lc-pokefree.js handles all interaction via event delegation.
 */
(function () {
  'use strict';

  var root = document.querySelector('.lc-pokefree');
  var grid = root && root.querySelector('[data-de-grid]');
  if (!grid) return;

  var titles = {};
  try { titles = JSON.parse(root.querySelector('[data-de-titles]').textContent); } catch (e) {}
  /* localized card strings (FR/NL sections override via [data-de-config]) */
  var CFG = { included: 'Enthalten', removeOne: 'Eins entfernen', addOne: 'Noch eins hinzufügen', add: 'Add', quickView: 'Quick View' };
  try {
    var cfgEl = root.querySelector('[data-de-config]');
    if (cfgEl) { var c = JSON.parse(cfgEl.textContent); for (var ck in c) CFG[ck] = c[ck]; }
  } catch (e) {}

  var BLOCK = [/^test/, /\(copy\)/, /\(test\)/, /delete/, /\(bundle\)/, /creator order/, /piece waterproof/, /piece for/, /^any /, /^new /, /^black friday/, /^3 for/, /^5 for/, /^7 for/, /^8 for/, /^10 /, /^15 /, /^20 /, /^schmuck-bundle/, /^necklace bundle/, /^comfort earrings bundle/, /gift card/, /geschenkkarte/, /carte cadeau/, /cadeaubon/, /^pick any/, /^coffret bijoux/, /^sieraden bundel/];

  var TYPE_MAP = {
    'necklace': 'Necklaces', 'bracelet': 'Bracelets', 'ring': 'Rings', 'earrings': 'Earrings',
    'anklet': 'Anklets', 'handchain': 'Hand Chains', 'hand chain': 'Hand Chains',
    'just dropped': 'Just Dropped', 'top page': 'Necklaces', 'choker': 'Necklaces',
    'pendant': 'Necklaces', 'bangle': 'Bracelets', 'cuff': 'Bracelets',
    'hoop': 'Earrings', 'stud': 'Earrings', 'huggie': 'Earrings', 'huggies': 'Earrings'
  };

  function categorize(type, title) {
    var t = (type || '').toLowerCase();
    if (TYPE_MAP[t]) return TYPE_MAP[t];
    title = (title || '').toLowerCase();
    /* order matters: "earring" contains "ring", "hand chain" contains "chain" */
    if (/anklet/.test(title)) return 'Anklets';
    if (/handchain|hand chain/.test(title)) return 'Hand Chains';
    if (/earring|hoop|huggie|stud/.test(title)) return 'Earrings';
    if (/necklace|choker|pendant|lariat|\bchain\b|paper ?clip/.test(title)) return 'Necklaces';
    if (/bracelet|bangle|cuff|\btennis\b/.test(title)) return 'Bracelets';
    if (/\brings?\b|\bband\b/.test(title)) return 'Rings';
    return 'Other';
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function thumb(src) {
    /* feed images are width=900 CDN URLs; swap to 480 for the card thumb */
    return src ? src.replace(/width=900/, 'width=480') : '';
  }

  var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var FEED = rootPath + 'collections/intl-bundle-feed?section_id=lc-bundle-feed&page=';
  var CACHE_KEY = 'lcDeFeedV2';
  var CACHE_TTL = 10 * 60 * 1000;

  function cardHtml(p) {
    var rawTitle = (p.title || '').replace(/ - Pre[Oo]rder/g, '').replace(/ - preorder/g, '').trim();
    var lower = rawTitle.toLowerCase();
    for (var i = 0; i < BLOCK.length; i++) if (BLOCK[i].test(lower)) return '';
    var tags = p.tags || [];
    if (tags.indexOf('bundle-builder') > -1) return '';
    if (!p.variants || !p.variants.length) return '';
    if (!p.variants.some(function (v) { return v.available; })) return '';

    var title = titles[rawTitle] || rawTitle;
    var cat = categorize(p.type, rawTitle);
    var data = { title: title, opts: p.opts || [], variants: p.variants, images: p.images || [] };
    var cardImg = thumb((p.images || [])[0]);

    var COMPACT = root.dataset.pfCompact === '1';
    if (COMPACT) {
      return '<div class="pf-card pf-card--cta" data-pf-card data-pid="' + p.id + '" data-category="' + esc(cat) + '" data-title="' + esc(title) + '">' +
        '<script type="application/json" data-pf-data>' + JSON.stringify(data).replace(/</g, '\\u003c') + '<\/script>' +
        '<button type="button" class="pf-img" data-pf-open>' +
          '<img src="' + esc(cardImg) + '" alt="' + esc(title) + '" loading="lazy" width="480" height="480">' +
          '<span class="pf-quickview">' + esc(CFG.quickView) + '</span>' +
          '<span class="pf-badge" data-pf-badge><i class="pf-badge-plus">+</i></span>' +
        '</button>' +
        '<div class="pf-qty" data-pf-qty hidden>' +
          '<button type="button" data-pf-minus aria-label="' + esc(CFG.removeOne) + '">−</button><b data-pf-n>0</b><button type="button" data-pf-plus aria-label="' + esc(CFG.addOne) + '">+</button>' +
        '</div>' +
        '<div class="pf-info pf-info--cta">' +
          '<button type="button" class="pf-name-btn" data-pf-open><span class="pf-name">' + esc(title) + '</span></button>' +
          '<span class="pf-included" data-pf-included hidden>' + esc(CFG.included) + '</span>' +
          '<button type="button" class="pf-add-btn" data-pf-add-direct>' + esc(CFG.add) + '</button>' +
        '</div>' +
      '</div>';
    }
    return '<div class="pf-card" data-pf-card data-pid="' + p.id + '" data-category="' + esc(cat) + '" data-title="' + esc(title) + '">' +
      '<script type="application/json" data-pf-data>' + JSON.stringify(data).replace(/</g, '\\u003c') + '<\/script>' +
      '<button type="button" class="pf-img" data-pf-open>' +
        '<img src="' + esc(cardImg) + '" alt="' + esc(title) + '" loading="lazy" width="480" height="480">' +
        '<span class="pf-badge" data-pf-badge><i class="pf-badge-plus">+</i></span>' +
      '</button>' +
      '<div class="pf-qty" data-pf-qty hidden>' +
        '<button type="button" data-pf-minus aria-label="' + esc(CFG.removeOne) + '">−</button><b data-pf-n>0</b><button type="button" data-pf-plus aria-label="' + esc(CFG.addOne) + '">+</button>' +
      '</div>' +
      '<button type="button" class="pf-info" data-pf-open>' +
        '<span class="pf-name">' + esc(title) + '</span>' +
        '<span class="pf-included" data-pf-included hidden>' + esc(CFG.included) + '</span>' +
      '</button>' +
    '</div>';
  }

  var skelGone = false;
  function renderBatch(products) {
    var html = '';
    products.forEach(function (p) { html += cardHtml(p); });
    grid.insertAdjacentHTML('beforeend', html);
    if (!skelGone) {
      var skel = root.querySelector('[data-de-skeleton]');
      if (skel) skel.remove();
      skelGone = true;
    }
    /* keep an active tab filter consistent for late-arriving cards */
    var active = root.querySelector('[data-pf-tab].active');
    if (active && active.dataset.pfTab !== 'All') {
      var cat = active.dataset.pfTab;
      grid.querySelectorAll('[data-pf-card]').forEach(function (c) {
        c.hidden = c.dataset.category !== cat;
      });
    }
  }

  function parseFeed(text) {
    var m = text.match(/<script type="application\/json" data-lc-feed>([\s\S]*?)<\/script>/);
    return m ? JSON.parse(m[1]) : null;
  }

  function fetchPage(n) {
    return fetch(FEED + n).then(function (r) { return r.text(); }).then(parseFeed);
  }

  /* session cache: repeat views render instantly */
  try {
    var cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
    if (cached && Date.now() - cached.time < CACHE_TTL && cached.products.length) {
      renderBatch(cached.products);
      return;
    }
  } catch (e) {}

  fetchPage(1).then(function (first) {
    if (!first) return;
    var all = first.products.slice();
    renderBatch(first.products);
    var rest = [];
    for (var n = 2; n <= Math.min(first.pages, 8); n++) rest.push(fetchPage(n));
    return Promise.all(rest).then(function (feeds) {
      feeds.forEach(function (f) {
        if (!f) return;
        all = all.concat(f.products);
        renderBatch(f.products);
      });
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ time: Date.now(), products: all })); } catch (e) {}
    });
  }).catch(function () {});
})();
